module.exports = __webpack_public_path__ + "img/extension.61ff8d01.svg";